import { BaseDataService } from "../../../services/base/BaseDataService";
import { StandartSolutionFolder } from "../models/StandartSolutionFolder";
import { StandartSolutionFolderQuery } from "../models/StandartSolutionFolderQuery";

export class StandartSolutionFolderService extends BaseDataService<StandartSolutionFolder, StandartSolutionFolderQuery> {
  protected prefixUrl = `StandartSolutionFolders`;

}
